import { Task } from "../../lib/api/tasks";
import { DraggableProvided } from "@hello-pangea/dnd";

interface TaskCardProps {
  task: Task;
  provided: DraggableProvided;
  onClick: () => void;
}

export function TaskCard({ task, provided, onClick }: TaskCardProps) {
  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className="bg-white p-4 rounded shadow-sm cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <div className="flex justify-between items-start mb-2">
        <h4 className="font-medium">{task.title}</h4>
        <span
          className={`px-2 py-1 text-xs rounded ${
            task.priority === "URGENT"
              ? "bg-red-100 text-red-800"
              : task.priority === "HIGH"
                ? "bg-orange-100 text-orange-800"
                : task.priority === "MEDIUM"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-green-100 text-green-800"
          }`}
        >
          {task.priority}
        </span>
      </div>
      {task.description && (
        <p className="text-sm text-gray-600 mb-2 line-clamp-2">
          {task.description}
        </p>
      )}
      <div className="text-xs text-gray-500">
        {task.type} · Updated {new Date(task.updatedAt).toLocaleDateString()}
      </div>
    </div>
  );
}
